import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

export const ContactInquiries = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [serviceFilter, setServiceFilter] = useState('');

  useEffect(() => {
    const fetchInquiries = async () => {
      setLoading(true);
      try {
        const inquiriesCollection = collection(db, 'contact_inquiries');
        const inquiriesSnapshot = await getDocs(inquiriesCollection);
        const inquiriesList = inquiriesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setInquiries(inquiriesList);
      } catch (error) {
        console.error("Error fetching inquiries: ", error);
      }
      setLoading(false);
    };

    fetchInquiries();
  }, []);

  const filteredInquiries = inquiries
    .filter(inquiry => {
      const searchLower = searchQuery.toLowerCase();
      return (
        inquiry.name.toLowerCase().includes(searchLower) ||
        inquiry.email.toLowerCase().includes(searchLower) ||
        (inquiry.company && inquiry.company.toLowerCase().includes(searchLower)) ||
        inquiry.message.toLowerCase().includes(searchLower)
      );
    })
    .filter(inquiry => {
      return serviceFilter ? inquiry.service === serviceFilter : true;
    });

  const exportToCsv = () => {
    const headers = ['Name', 'Email', 'Company', 'Service', 'Message'];
    const csvContent = [
      headers.join(','),
      ...filteredInquiries.map(inquiry => [
        `"${inquiry.name}"`,
        `"${inquiry.email}"`,
        `"${inquiry.company || ''}"`,
        `"${inquiry.service}"`,
        `"${inquiry.message.replace(/"/g, '')}"`
      ].join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.href) {
      URL.revokeObjectURL(link.href);
    }
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.setAttribute('download', 'contact-inquiries.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1 className="display-lg mb-8" style={{ color: 'var(--text-primary)' }}>Contact Inquiries</h1>
      
      <div className="flex justify-between mb-4">
        <input
          type="text"
          placeholder="Search inquiries..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="px-4 py-2 rounded-lg border"
        />
        <div className="flex space-x-2">
          <select
            value={serviceFilter}
            onChange={(e) => setServiceFilter(e.target.value)}
            className="px-4 py-2 rounded-lg border"
          >
            <option value="">All Services</option>
            <option value="general">General Inquiry</option>
            <option value="business-automation">Business Process Automation</option>
            <option value="devops">DevOps & Infrastructure</option>
            <option value="cloud">Cloud Automation</option>
            <option value="data">Data & Analytics</option>
            <option value="custom">Custom Solution</option>
          </select>
          <button onClick={exportToCsv} className="px-4 py-2 rounded-lg border">Export to CSV</button>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full" style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border-subtle)' }}>
          <thead>
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" style={{ color: 'var(--text-secondary)' }}>Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" style={{ color: 'var(--text-secondary)' }}>Email</th>
              <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" style={{ color: 'var(--text-secondary)' }}>Company</th>
              <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" style={{ color: 'var(--text-secondary)' }}>Service</th>
              <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider" style={{ color: 'var(--text-secondary)' }}>Message</th>
            </tr>
          </thead>
          <tbody style={{ color: 'var(--text-primary)' }}>
            {filteredInquiries.map((inquiry) => (
              <tr key={inquiry.id} style={{ borderTop: '1px solid var(--border-subtle)' }}>
                <td className="px-6 py-4 whitespace-nowrap">{inquiry.name}</td>
                <td className="px-6 py-4 whitespace-nowrap">{inquiry.email}</td>
                <td className="px-6 py-4 whitespace-nowrap">{inquiry.company}</td>
                <td className="px-6 py-4 whitespace-nowrap">{inquiry.service}</td>
                <td className="px-6 py-4 whitespace-nowrap">{inquiry.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};